import React from "react"
import { nanoid } from "nanoid"

function Equipment({ equipment }) {
    return (
        <>
            { equipment.length === 0 ? null : <h3>Equipment</h3> }
            <section className="container">
                {
                    equipment.map( item => {
                        return  <div key={nanoid()} className="tile equipmentTile">
                            <img
                                className="equipmentImg" 
                                src={`https://spoonacular.com/cdn/equipment_500x500/${item.image}`} 
                                alt="Equipment" />
                            <p>{item.name}</p>
                        </div>
                    })
                }
            </section>
        </>
    )
}

export default Equipment
